import * as Factory from 'factory.ts'
import faker from 'faker'

import {
  Approver,
  type ApproverConstructor,
} from '@webapp/core/entities/internal/Approver'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { PrimaryCategoryFactory } from '../PrimaryCategory/PrimaryCategory.factory'
import { SecondaryCategoryFactory } from '../SecondaryCategory/SecondaryCategory.factory'

export const ApproverConstructorFactory =
  Factory.Sync.makeFactory<ApproverConstructor>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    profileImage: Factory.each(
      () => 'https://i.pravatar.cc/' + faker.random.number({ min: 1, max: 200 })
    ),
    approvalDelegatee: Factory.each(() => null),
    primaryCategory: Factory.each(() => PrimaryCategoryFactory.build()),
    secondaryCategory: Factory.each(() => SecondaryCategoryFactory.build()),
    level: Factory.each(() => undefined),
    groupName: Factory.each(() => faker.commerce.department()),
  })

export const ApproverFactory = EntityFactory(
  Approver,
  ApproverConstructorFactory
)
